export default class ageValidator {
    constructor() {
    }

    validate(field, value) {
        const minAge = field.dataset.min * 1;
        const maxAge = field.dataset.max * 1;
        value = value * 1;

        return value >= minAge && value <= maxAge;
    }
}
